(function () {
    'use strict';

    run.admin.parts.rackootFollow = function () {
        // Real button for logged in users
        function shareButtonSetLoading()
        {
            const follow_button = document.getElementById('rackoots_items__change_follow');
            const follow_button_icon = follow_button.querySelectorAll('i')[0];
            const follow_button_span = follow_button.querySelectorAll('span')[0];

            follow_button.setAttribute('disabled', 'disabled');
            follow_button_icon.classList = '';
            follow_button_icon.classList.add('fas', 'fa-spinner', 'fa-spin');
        }

        function shareButtonSetFollowing()
        {
            const follow_button = document.getElementById('rackoots_items__change_follow');
            const follow_button_icon = follow_button.querySelectorAll('i')[0];
            const follow_button_span = follow_button.querySelectorAll('span')[0];

            follow_button_span.innerHTML = follow_button.dataset.textUnfollow;
            follow_button.dataset.following = 'true';
            follow_button.removeAttribute('disabled');
            follow_button_icon.classList = '';
            follow_button_icon.classList.add('fas', follow_button.dataset.iconUnfollow);
        }

        function shareButtonSetNotFollowing()
        {
            const follow_button = document.getElementById('rackoots_items__change_follow');
            const follow_button_icon = follow_button.querySelectorAll('i')[0];
            const follow_button_span = follow_button.querySelectorAll('span')[0];

            follow_button_span.innerHTML = follow_button.dataset.textFollow;
            follow_button.dataset.following = 'false';
            follow_button.removeAttribute('disabled');
            follow_button_icon.classList = '';
            follow_button_icon.classList.add('fas', follow_button.dataset.iconFollow);
        }

        function addRackootToFollowedList(name, uuid, url)
        {
            const ul = document.getElementById('rackoots_followed_dropdown_list');
            const no_items_li_id = ul.dataset.noItemsLiId;
            const no_items_li = document.getElementById(no_items_li_id);
            const rackoot_data = document.getElementById('rackoot_data');

            if (no_items_li != null) {
                no_items_li.remove();
            }

            let li = document.createElement('li');
            li.dataset.rackootUuid = uuid;
            li.dataset.changed = 'false';
            li.classList.add('nav_item__current', 'rackoot__item');
            li.style.setProperty('--rackoot-color', rackoot_data.dataset.color);

            let a = document.createElement('a');
            a.href = url;

            let span = document.createElement('span');
            span.classList.add('rackoot__name');
            span.innerHTML = name;

            let i = document.createElement('i');
            i.classList.add('rackoot__updated_indicator', 'fas', 'fa-circle');

            a.appendChild(i);
            a.appendChild(span);
            li.appendChild(a);
            ul.appendChild(li);
        }

        function removeRackootFromFollowedList(uuid)
        {
            const target = document.getElementById('rackoots_followed_dropdown_list');
            const items = target.querySelectorAll('[data-rackoot-uuid="'+uuid+'"');
            if (items[0] !== null) {
                items[0].remove();
            }

            // Should we add a "No rackoots followed" item here?
            const ul = document.getElementById('rackoots_followed_dropdown_list');
            const current_items = ul.querySelectorAll('li');
            if (current_items.length == 0) {
                const li = document.getElementById('template_no_followed').innerHTML;
                ul.innerHTML = li;
            }
        }

        document.body.addEventListener('click', function(e) {
            let clicked_follow_button = e.target.closest('#rackoots_items__change_follow');
            if (clicked_follow_button) {
                shareButtonSetLoading();

                const csrf_name = document.getElementsByName('csrf_name')[0].value;
                const csrf_value = document.getElementsByName('csrf_value')[0].value;
        
                const rackoot_data = document.getElementById('rackoot_data');

                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', rackoot_data.dataset.uuid);

                switch (clicked_follow_button.dataset.following) {
                    case 'true':
                        axios.post(GlobalRoutes.rackoots.unfollow, data)
                        .then(function (response) {
                            shareButtonSetNotFollowing();
                            removeRackootFromFollowedList(rackoot_data.dataset.uuid);
                        })
                        .catch(function (error) {
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                    break;
                    case 'false':
                        axios.post(GlobalRoutes.rackoots.follow, data)
                        .then(function (response) {
                            shareButtonSetFollowing();
                            addRackootToFollowedList(rackoot_data.dataset.name, rackoot_data.dataset.uuid, rackoot_data.dataset.url);
                        })
                        .catch(function (error) {
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                    break;
                }
            }
        });

        // Fake Button
        const fake_button_container = document.getElementById('rackoots_items__follow_no_user');
        if (fake_button_container !== null) {
            const fake_button = fake_button_container.querySelector('button');
            fake_button.addEventListener('click', function(e) {
                const html = 
                    translations.rackoots.follow.messages.anonymous+`
                    <div class="mt-4">
                        <a class="btn btn-lg btn-primary" href="`+GlobalRoutes.auth.register+`">`+translations.auth.createAccount+`</a>
                        <a class="btn btn-lg btn-primary" href="`+GlobalRoutes.auth.login+`">`+translations.auth.login+`</a>
                    </div>
                `;
                Swal.fire({
                    title: null,
                    html: html,
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                });
            });
        }
    }
})();